var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"avatar circle",staticStyle:{"vertical-align":"middle"},attrs:{"width":_vm.size || 64,"height":_vm.size || 64,"src":_vm._f("blockie")(_vm.address)}})}
var staticRenderFns = []

export { render, staticRenderFns }